import React from 'react'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import { useSingleNotification } from '@hooks/admin/useBackgroundJobNotification'
import SluggishProductsPage from '@components/shared/sluggish_products/SluggishProductsPage'
import ListPageHeader from '@shared/ListPageHeader'

import { sluggishProductService } from '@services/admin/sluggishProductService'

export default function AdminSluggishProductsIndex() {
  const { addJob } = useAdminNotification()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.sluggish']}
      />
      <SluggishProductsPage
        role="admin"
        service={sluggishProductService}
        addJob={addJob}
        useSingleNotification={useSingleNotification}
      />
    </div>
  )
}
